import { useMatch } from "src/router";

export const KNOWLEDGE_BASE = "/context-hub/knowledge";

/** The Knowledge page segment the URL is on, e.g. `files` for `files/<id>`. */
export const useKnowledgeSection = (): string | undefined =>
  // Route match, so a page's sub-routes keep its section active.
  useMatch(`${KNOWLEDGE_BASE}/:section/*`)?.params.section;
